import axios from 'axios';

const baseURL = '/public/api';

export const getApiList = () => {
  const url = `${baseURL}/enrollmentList`;
  return axios.post(url);
};

export const getSubscriptionList = () => {
  const url = `${baseURL}/subscriptions/subscribables`;
  return axios.get(url);
};

export const registerPartner = data => {
  const url = `${baseURL}/enroll`;
  return axios.post(url, data);
};

export const emailVerificationCode = token => {
  const url = `${baseURL}/emailVerification/${token}`;
  return axios.get(url);
};

export const resendEmail = token => {
  const url = `${baseURL}/resendEmail/${token}`;
  return axios.get(url);
};

export const getFilters = () => {
  const url = `${baseURL}/filters`;
  return axios.post(url);
};
